import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import { request } from '../../../config';
import YesNoModal from '../../../copms/Modal/YesNoModal';
import { Autocomplete } from '@mui/material';

class Create extends Component {
    state = {
        status: 1,
        excelFileOutline: false,
        toDate: new Date(),
        fromDate: new Date(),
        currentPage: 1,
        lastPage: 0,
        search: '',
        banks: [],
        tin: null,
        // isLoading: false
    }

    setValues = (value, name) => {
        let newFormData = {
            ...this.state.formData,
            [name]: value
        };
        this.setState({ formData: newFormData })
    };

    componentDidMount() {
        this.getList();
    };

    getList = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        // this.setState({ isLoading: true })
        let getListRequestBody = {
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        }
        fetch(request("account/getBanksForOpenBanking", getListRequestBody))
            .then(res => res.text())
            .then((getListResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getListResponse = JSON.parse(getListResponseJSON);
                if (getListResponse.status.statusCode !== 1) {
                    if (getListResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getListResponse.status.statusCode));
                    }
                }
                this.props.updateAppState('isLoadingTransparentBackground', false);
                this.setState({ banks: getListResponse?.banks ? (getListResponse?.banks?.length != 0 ? getListResponse?.banks : []) : [] });
                // this.setState({ isLoading: false })
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    };

    create = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        // this.setState({ isLoading: true })
        let getListRequestBody = {
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            tin: this.state.tin,
            deviceIdType: "WEB"
        }
        fetch(request("account/createConsent", getListRequestBody))
            .then(res => res.text())
            .then((getListResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getListResponse = JSON.parse(getListResponseJSON);
                if (getListResponse.status.statusCode !== 1) {
                    if (getListResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getListResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                } else {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    getListResponse.redirectType == 2 ?
                        this.props.alertState(true, 'success', this.props.t('successful operation'), this.props.t(getListResponse.psuMessage), null, null, () => this.props.history.push('/dashboard/open-banking/list/consents/sent'))
                        :
                        this.props.alertState(true, 'success', null, this.props.t(getListResponse.psuMessage), null, null, () => { window.open(getListResponse._links.scaRedirect.href, '_blank', 'noopener,noreferrer'); this.props.history.push('/dashboard/open-banking/list/consents/sent') })
                    // this.setState({ isLoading: false })
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    };

    render() {
        let { banks, open } = this.state;
        let { t } = this.props;
        return (
            <>
                <YesNoModal open={open} title={t('You are being redirected to the selected bank’s app to confirm account access')} onClose={() => this.setState({ open: false })} triggerFunc={(bool) => bool ? this.create() : this.setState({ open: false })} />
                <div className="dashboard-transfer-list-header">
                    <div className="dashboard-transfer-list-header-container dashboard-transfer-list-header-container__left">
                        <NavLink exact to="/dashboard/open-banking/consent/create" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("Create new consent")}</NavLink>
                    </div>
                </div>
                <div className="dashboard-salary-order-container" style={{ overflow: 'visible', minHeight: '68vh', justifyContent: 'space-between' }}>
                    <div className="dashboard-account-container-component align-items-end">
                        <Autocomplete
                            className='open-banking'
                            disablePortal
                            options={banks}
                            getOptionLabel={option => option.bankName}
                            onChange={(event, value) => this.setState({ tin: value?.bankTin })}
                            sx={{ width: 312 }}
                            renderInput={(params) => <TextField {...params} placeholder={t('Choose')} label={t('Organization')} />}
                        />
                    </div>
                    <div className="d-flex justify-content-end" style={{ gap: '1rem' }}>
                        <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-main" onClick={this.create}>{t("continue")}</button>
                        <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-outline">{t("cancel")}</button>
                    </div>
                </div>
            </>
        )
    }
}

export default translate("translation")(Create);